export default {
  setProgramList (state, data) {
    state.programList = data
  },
  setScreenPositionList (state, data) {
    state.screenPositionList = data
  },
  setTVNoList (state, data) {
    state.tvNoList = data
  },
  clearProgramDropDownList (state) {
    state.programList = []
    state.screenPositionList = []
    state.tvNoList = []
  }
}



// WEBPACK FOOTER //
// ./src/store/program/mutations.js